var get_attr_path = window.get_attr_path;
var get_attr_path;
get_attr_path = function (obj, path) {
  var result, segments;
  segments = path.split('.');
  result = obj;
  _.each(segments, function (attribute) {
    return result = result[attribute];
  });
  return result;
};
window.JST || (window.JST = {});
window.Academia.View = Backbone.View.extend({
  initialize: function () {
    if (this.options.record_events_for) {
      this.notifier = new c.Server.Notification(this.options.record_events_for);
    }
    return this._find_elements();
  },
  delegateEvents: function (events) {
    var new_events, splitter;
    if (!(events || (events = this.events))) {
      return;
    }
    new_events = {};
    splitter = /^(\S+)\s*(.*)$/;
    _.each(events, function (_this) {
      return function (method, key) {
        var _, event_name, real_selector, ref, selector;
        ref = key.match(splitter), _ = ref[0], event_name = ref[1], selector = ref[2];
        if (selector.match(/^%/)) {
          real_selector = get_attr_path(_this.elements, selector.slice(1));
          return new_events[event_name + ' ' + real_selector] = method;
        } else {
          return new_events[key] = method;
        }
      };
    }(this));
    return Backbone.View.prototype.delegateEvents.call(this, new_events);
  },
  render: function (properties) {
    var ref, template;
    if (properties == null) {
      properties = {};
    }
    template = properties['template'] || this.template || JST[this.jstTemplate] || function () {
      throw "Must have a template or jstTemplate property to use the " + "default render()";
    }();
    this.$el.html(template($.extend(true, {}, properties['defaults'], (ref = this.model) != null ? ref.attributes : void 0, properties['override'])));
    this._find_elements();
    return this;
  },
  remove: function (silent) {
    if (silent == null) {
      silent = false;
    }
    Backbone.View.prototype.remove.apply(this, arguments);
    if (!silent) {
      this.trigger('remove');
    }
    return this;
  },
  _find_elements: function (target, elements) {
    if (target == null) {
      this.$els = {};
      target = this.$els;
    }
    if (elements == null) {
      this.elements || (this.elements = {});
      elements = this.elements;
    }
    return _.each(elements, function (_this) {
      return function (selector, name) {
        if (typeof selector === 'object') {
          target[name] = {};
          return _this._find_elements(target[name], selector);
        } else {
          return target[name] = _this.$el.find(selector);
        }
      };
    }(this));
  },
  _record_event: function (event_name, error) {
    if (typeof $a !== "undefined" && $a !== null ? $a.log : void 0) {
      $a.log(event_name);
    }
    if (this.notifier != null) {
      return this.notifier.notify({
        event: event_name,
        user_id: $current_user.id,
        error: error,
        source: this.options.source,
        user_time: parseInt(new Date().getTime() / 1000)
      });
    }
  },
  stopPropagation: function (e) {
    return e.stopPropagation();
  }
});
window.get_attr_path = get_attr_path;